import React from "react";
import { getToken } from "../../config/azureConfig";

class AuthPage extends React.Component {
  render() {
    return (
        <div>
          <h1>Authorised!</h1>
          <h4>You are now authorised, hooray! <span role="img" aria-label="celebrate">🎉</span> { JSON.stringify(getToken()) }</h4>
        </div>
    );
  }
}

export default AuthPage;
